import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StepNumberWrapper = styled('div')(({ theme }) => ({
  background: '#EAF2FD',
  width: '2rem',
  height: '2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '4px'
}));

export const StepWrapper = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 600
}));

export const TitleWrapper = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 600,
  textAlign: 'left'
}));
